import { useQuery } from '@tanstack/react-query';
import { authService } from '../../../services/authService';
import { getApiUrl } from '../../../config/config';
import apiClient from '../../api/client';
import { extractErrorMessage } from '../../../utils/errorHandler';

export const authQueryKeys = {
  all: ['auth'],
  verifyToken: (token) => [...authQueryKeys.all, 'verifyToken', token],
};

export const verifyTokenQueryFn = async (token) => {
  const verifyUrl = getApiUrl('AUTH', 'VERIFY_TOKEN');
  
  try {
    const response = await apiClient.post(verifyUrl, {
      token
    });

    if (response.data.isSuccess || response.status === 200) {
      return { 
        isValid: true, 
        data: response.data,
        token 
      };
    } else {
      return { 
        isValid: false, 
        error: response.data.error || 'Token verification failed' 
      };
    }
  } catch (error) {
    // Handle errors consistently
    if (error.response?.status === 401) {
      return { 
        isValid: false, 
        error: 'Token is invalid or expired', 
        shouldClearToken: true 
      };
    }

    return { 
      isValid: false, 
      error: extractErrorMessage(
        error.response?.data || error,
        'Token verification failed'
      )
    };
  }
};

export const useVerifyToken = (token = null, enabled = true) => {
  const tokenToVerify = token || authService.getCurrentToken();
  
  return useQuery({
    queryKey: authQueryKeys.verifyToken(tokenToVerify),
    queryFn: () => verifyTokenQueryFn(tokenToVerify),
    enabled: enabled && !!tokenToVerify,
    staleTime: 5 * 1000, // 5 seconds - very short cache (token verification is time-sensitive)
    gcTime: 10 * 1000, // 10 seconds - cache retention (formerly cacheTime)
    retry: false, // Don't retry token verification (invalid tokens shouldn't retry)
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnReconnect: false, // Don't refetch on reconnect
  });
};

